<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
      :data-source='reportSummary'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ height: localHeight, width: localWidth }"
      :allowColumnResizing="true"
      :rowAlternationEnabled="false"
      :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
      :summary="summary"
      :row-alternation-enabled="true"
      :allow-column-reordering="true"
      :allow-column-dragging="false"
      @content-ready="onContentReady")
      dx-scrolling(mode='standard', :useNative="false")
      dx-paging(:pageSize="100000")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="false", expand-mode="rowClick")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'FuelAnalysis',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNumRow',
        caption: '№',
        fixed: true,
        width: this.reportData.IsSummary ? 200 : 50,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' })),
        width: 90,
      }, {
        dataField: 'Begin',
        caption: 'Начало события',
        alignment: 'center',
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' })),
        width: 120,
      }, {
        dataField: 'End',
        caption: 'Окончание события',
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' })),
        alignment: 'center',
        width: 120,
      }, {
        dataField: 'EventType',
        caption: 'Тип события',
        alignment: 'center',
        width: 120,
      }, {
        dataField: 'ExtValue',
        caption: 'Заправка Чек',
        alignment: 'center',
        width: 130,
        customizeText: params => (!params.value ? undefined : params.value.toFixed(1)),
      }, {
        dataField: 'GisValue',
        caption: 'Заправка ДУТ' +
          '',
        alignment: 'center',
        width: 130,
        customizeText: params => (!params.value ? undefined : params.value.toFixed(1)),
      }, {
        dataField: 'GisDrainValue',
        caption: 'Слив ДУТ',
        alignment: 'center',
        width: 130,
        customizeText: params => (!params.value ? undefined : params.value.toFixed(1)),
      }, {
        dataField: 'DifferencePercent',
        caption: '% откл. заправок',
        alignment: 'center',
        minWidth: 100,
      }, {
        dataField: 'RowNum',
        caption: '',
        groupIndex: 1,
        width: 0,
      }],
      summaryColoumn: [{
        column: 'Date',
        name: 'Date',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'ExtValue',
        name: 'ExtValue',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'GisValue',
        name: 'GisValue',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'GisDrainValue',
        name: 'GisDrainValue',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'DifferencePercent',
        name: 'DifferencePercent',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      summaryConvert: [],
      index: 0,
      obj: 0,
    };
  },
  watch: {
    reportData (value) {
      this.convertData(this.reportData);
      this.getSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    this.convertData(this.reportData);
    this.getSummary();
  },
  methods: {
    convertData (data) {
      this.summaryConvert = [];
      if (data.IsSummary) {
        data.Data.Data.forEach((items) => {
          this.pushData(items.Rows, items.ObjectName);
        });
      } else {
        this.pushData(data.Data.Data.Rows);
      }
      this.reportSummary = this.summaryConvert;
    },

    pushData (rows, name = null) {
      rows.forEach((_row, i) => {
          _row.Rows.forEach((item, j) => {
            const rowItem = {};
            Object.assign(rowItem, item);
            rowItem.RowNumRow = `${(i + 1)}.${j + 1}`;
            rowItem.RowNum = i + 1;
            rowItem.ObjectName = name;
            this.summaryConvert.push(rowItem);
          });
        });
    },

    getSummary () {
      if (!this.reportData.IsSummary) {
        this.index = 0;
        this.summary = {
          calculateCustomSummary: (options) => {
            if (this.index >= this.reportData.Data.Data.Rows.length) {
              this.index = 0;
            }
            this.createTotalValue(options, this.reportData.Data.Data, 0);
          },
          groupItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (this.obj >= this.reportData.Data.Data.length) {
              this.obj = 0;
            }
            if (this.index >= this.reportData.Data.Data[this.obj].Rows.length) {
              this.obj += 1;
              this.index = 0;
            }
            this.createTotalValue(options, this.reportData.Data.Data[this.obj], 1);
          },
          groupItems: this.summaryColoumn,
        };
      }
    },

    createTotalValue (options, data, index) {
      if (options.summaryProcess === 'start' && options.groupIndex === index) {
        const value = options;
        const totalValue = data.Rows[this.index][`${options.name}`];
        if (totalValue !== undefined) {
          if (options.name === 'Date') {
            value.totalValue = (new Date(totalValue * 1000).toLocaleDateString('ru', { timeZone: 'UTC' })).toString();
          } else {
            value.totalValue = totalValue ? totalValue.toFixed(1) : totalValue;
          }
        }
        if (options.name === 'DifferencePercent') {
          this.index += 1;
        }
      }
    },
  },
};
</script>
